import { fn } from "@/core.js"

fn.toArray = function () {
  return Array.from(this)
}
